import React, {useEffect, useMemo, useState} from "react";
import {Table, Select, theme, Flex, Tooltip, Button, Space, Modal, Empty} from "antd";

import "../TasksPage/TasksPage.css";
import {axiosInstance} from "../../api/axiosInstance";
import {
    DeleteOutlined,
    ExclamationCircleOutlined,
    SearchOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    CheckCircleFilled, PlusOutlined
} from "@ant-design/icons";
import {toast} from "react-toastify";
import ModalComponent from "../../components/ModalComponent/ModalComponent";
import SupplierAdministrationForm
    from "../../components/Administration/Suppliers/SupplierAdministrationForm/SupplierAdministrationForm";
import PostWithComments from "../../components/Noticeboard/PostWithComments/PostWithComments";
import {useForm} from "antd/lib/form/Form";

import dayjs from "dayjs";
import TodoSubmitForm from "../../components/Todo/TodoSubmitForm/TodoSubmitForm";
import TodoTable from "../../components/Todo/TodoTable/TodoTable";
import TasksTable from "../../components/Tasks/TasksTable/TasksTable";

const TasksPage = ({userData}) => {
    const {token} = theme.useToken();

    const [form] = useForm()

    const [tasks, setTasks] = useState([]);
    const [todos, setTodos] = useState([]);
    const [selectedProject, setSelectedProject] = useState(-1);
    const [projects, setProjects] = useState([]);

    const [showModal, setShowModal] = useState(false);
    const [showTodoModal, setShowTodoModal] = useState(false);

    const [rowData, setRowData] = useState({})
    const [posts, setPosts] = useState([]);
    const [post, setPost] = useState({})
    const [comments, setComments] = useState([]);

    const [arrow, setArrow] = useState("Show");
    const [childKey, setChildKey] = useState(0);

    const mergedArrow = useMemo(() => {
        if (arrow === "Hide") {
            return false;
        }

        if (arrow === "Show") {
            return true;
        }

        return {
            pointAtCenter: true,
        };
    }, [arrow]);

    const fetchTasks = () => {
        axiosInstance
            .post("/api/v1/task/find-all-by-project", {projectId: selectedProject})
            .then((res) => setTasks(res.data));
    };

    const fetchTodos = () => {
        axiosInstance
            .get("/api/v1/todo")
            .then((res) => setTodos(res.data));
    };

    const fetchUserProjectsByUserId = (userId) => {
        const isAdminRole = userData?.authorities?.includes('ROLE_ADMINISTRATOR');
        return axiosInstance.get(isAdminRole ? `/api/v1/projects/find-all` : `/api/v1/projects/find-all-by-user/${userId}`).then((res) => {
            const userProjects = res.data?.map((x) => {
                return {
                    value: x.id,
                    label: `${x.name} - ${x.investor.name}`,
                };
            });
            setProjects([{value: -1, label: 'Svi zadaci'}, {value: '', label: 'Javno'}].concat(userProjects));
        });

    };

    const fetchPost = (likeableId, likeType) => {
        return axiosInstance
            .post(`/api/v1/noticeboard/find-post-by`, {likeableId: likeableId, likeType: likeType})
            .then((res) => {
                setPosts([].concat(res.data));
                setPost({...res.data, seen: true});
                return res.data.id
            }).then((postId) => {
                fetchComments(postId);
            });
    }
    const fetchComments = (postId) => {
        axiosInstance.get(`/api/v1/noticeboard/find-comments-by-post/${postId}`)
            .then(res => setComments(res.data))
    }


    const handleSubmitTodo = (values) => {
        axiosInstance.post(`/api/v1/todo`, {
            message: values.message,
            deadlineDate: values.deadlineDate ? values.deadlineDate : null,
            deadlineTime: values.deadlineTime ? values.deadlineTime.format("HH:mm:ss") : null,
        }).then(res => {
            setShowTodoModal(false);
            fetchTodos();
        })
    }

    useEffect(() => {
        fetchTasks();
        fetchTodos();
        fetchUserProjectsByUserId(userData.userId);
    }, []);

    useEffect(() => {
        fetchTasks();
    }, [selectedProject]);

    const pageStyle = {
        maxWidth: "none",
        background: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        padding: 24,
        height: "100%",
    };

    const rowClassName = (record, index) => {
        if (record.done) {
            return 'done';
        } else {
            return "not-done"
        }
    };

    return (
        <>
            <div className={"tasks-page"} style={pageStyle}>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <h3>{`ZADACI`}</h3>
                    <Select
                        style={{width: "200px", alignSelf: "center"}}
                        placeholder={"Odaberite posao"}
                        value={selectedProject}
                        options={projects}
                        onChange={(value) => {
                            setSelectedProject(value);
                        }}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                        }
                    ></Select>
                </div>

                <TasksTable
                tableData={tasks}
                fetchPost={(likeableId, likeType) => fetchPost(likeableId, likeType)}
                fetchTasks={fetchTasks}
                setChildKey={setChildKey}
                setRowData={setRowData}
                setShowModal={setShowModal}
                ></TasksTable>

                <div>
                    <div style={{display: "flex", alignItems: "center", gap: "16px", marginTop: "16px"}}>
                        <div>
                            <h3>TODO LISTA</h3>
                        </div>
                        <div>
                            <Button type="dashed" icon={<PlusOutlined/>} onClick={() => setShowTodoModal(true)}/>
                        </div>
                    </div>
                    <TodoTable tableData={todos} fetchTodos={() => fetchTodos()}/>
                    </div>
            </div>
            <ModalComponent
                show={showModal}
                onOk={() => {
                    setComments([]);
                    setShowModal(false);
                }}
                onCancel={() => {
                    setComments([]);
                    setShowModal(false);
                }}
                showFooter={false}
                width={"700px"}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: 'center',
                        alignItems: 'center',
                        justifyItems: "center"
                    }}
                >
                    <PostWithComments
                        key={childKey}
                        likeableId={rowData.likeableId}
                        likeType={rowData.likeType}
                        previewMode={true}
                        post={post}
                        comments={comments}
                        selectedProject={selectedProject}
                        setPosts={setPosts}
                        userId={post?.user?.id}
                        message={post.message}
                        username={`${post?.user?.nameStr}`}
                        createdAt={post.tstamp}
                        //numberOfComments={post?.numberOfComments}
                        fetchComments={(postId) => fetchComments(postId)}
                        expandComments={true}
                        handlePostDelete={(postId) => {
                        }}
                        style={{width: '100%'}}
                    ></PostWithComments>
                </div>

            </ModalComponent>
            <ModalComponent
                show={showTodoModal}
                onOk={() => {
                    setShowTodoModal(false);
                }}
                onCancel={() => {
                    setShowTodoModal(false);
                }}
                showFooter={false}
                width={"700px"}
            >
                <TodoSubmitForm
                    handleSubmitTodo={(values) => handleSubmitTodo(values)}>
                </TodoSubmitForm>

            </ModalComponent>
        </>
    );
};
export default TasksPage;
